import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, filter } from "rxjs/operators";

import { TransferStateService } from "src/app/core/services/transfer-state.service";
import { Transferable } from "src/app/core/decorators/transferable.decorator";
import { Category } from "../models/category.model";

@Injectable({
  providedIn: "root",
})
export class CategoryService extends TransferStateService {
  path = "categories";

  @Transferable("CategoryService.index")
  index(): Observable<Category[]> {
    try {
      return this.http
        .get<any>(`${this.apiUrl}/${this.path}`)
        .pipe(filter((response) => !!response))
        .pipe(map((response) => response.data));
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  show(id: string | number): Observable<Category> {
    try {
      return this.http
        .get<any>(`${this.apiUrl}/${this.path}/${id}`)
        .pipe(filter((response) => !!response))
        .pipe(map((response) => response.data));
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}
